import { DocumentServicesObject, PageRef } from '@wix/document-services-types';
import {
  InstallOptions,
  InstallCallbacks,
} from '@wix/editor-platform-host-integration-apis';
import { createDependenciesDriver } from './appDependenciesDriver';
import * as unifiedComponents from './unifiedComponents/installation/addApps';
import { PlatformContext } from '../../types/platformApi';
import { IExperimentsApiAdapter } from '../utils/experimentsApiAdapter';

export interface InstallAppWithInstallerBuilderOptions {
  origin: {
    type: string;
    initiator: string;
    info: {
      type: string;
    };
  };
  appVersion?: string;
  callback: (data: any) => void;
}

const installApps = (
  context: PlatformContext,
  documentServices: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
  appDefinitionIds: string[],
  installOptions?: InstallOptions,
  callbacks?: InstallCallbacks,
) => {
  return unifiedComponents.installApps(
    context,
    documentServices,
    experimentsAPI,
    appDefinitionIds,
    installOptions,
    callbacks,
  );
};

export { createDependenciesDriver, installApps };
